<template>
  <div class="grid grid-cols-1 md:grid-cols-3 gap-2">
    <!-- Búsqueda por nombre -->
    <div class="flex items-center gap-2">
      <font-awesome-icon 
        icon="search" 
        class="text-slate-400 w-4 h-4 flex-shrink-0" 
      />
      <input
        v-model="searchTerm"
        placeholder="Buscar por nombre..."
        class="input-field w-full h-9"
      />
    </div>
    
    <!-- Filtro por laboratorio -->
    <select v-model="selectedLab" class="input-field h-9">
      <option value="">Todos los laboratorios</option>
      <option v-for="lab in laboratories" :key="lab.id" :value="lab.name">
        {{ lab.name }}
      </option>
    </select>
    
    <!-- Filtro por tiempo de entrega -->
    <select v-model="selectedDeliveryTime" class="input-field h-9">
      <option value="">Todos los tiempos de entrega</option>
      <option v-for="time in deliveryTimes" :key="time" :value="time">
        {{ time }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps<{
  laboratories: { id: string; name: string }[];
  deliveryTimes: string[];
}>();

const emit = defineEmits<{
  'update:filters': [{ search: string; lab: string; deliveryTime: string }];
}>();

const searchTerm = ref('');
const selectedLab = ref('');
const selectedDeliveryTime = ref('');

// Emitir cambios en los filtros
watch([searchTerm, selectedLab, selectedDeliveryTime], () => {
  emit('update:filters', {
    search: searchTerm.value,
    lab: selectedLab.value,
    deliveryTime: selectedDeliveryTime.value
  });
});

// Método para resetear filtros
const resetFilters = () => {
  searchTerm.value = '';
  selectedLab.value = '';
  selectedDeliveryTime.value = '';
};

defineExpose({ resetFilters });
</script>